import { render, staticRenderFns } from "./CardTarjaEnqueteTVZFullScreen.vue?vue&type=template&id=630083f0&scoped=true"
import script from "./CardTarjaEnqueteTVZFullScreen.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteTVZFullScreen.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteTVZFullScreen.vue?vue&type=style&index=0&id=630083f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630083f0",
  null
  
)

export default component.exports